<template>
  <b-modal ref="route-modal" id="modal-center-routes" hide-footer>
    <template v-slot:modal-header>
     <b-row style="width:100%;">
        <b-icon @click="closeRoute" class="routes-back-arrow" icon="arrow-left" variant="dark" font-scale="0.5"></b-icon>
        <h5 style="margin-left:5%;margin-top:10px">{{ $t('message.select_route') }}</h5>
     </b-row>
    </template>
    <template class="route-modal-body" v-slot:default>
      <b-input-group  size="sm" class="mb-2" style="height:48px;">
        <b-input-group-prepend is-text style="height:48px;">
          <b-icon icon="square-fill" variant="info" font-scale="0.5"></b-icon>
        </b-input-group-prepend>
        <b-form-input :disabled="showLoader" style="height:48px;" v-model="loadingCity" @input="searchLoading" :value="loadingCity" type="search" :placeholder="$t('message.loadig_city')"></b-form-input>
      </b-input-group>
      <b-input-group  size="sm" class="mb-2" style="height:48px;">
        <b-input-group-prepend is-text style="height:48px;">
          <b-icon icon="square-fill" variant="secondary" font-scale="0.5"></b-icon>
        </b-input-group-prepend>
        <b-form-input :disabled="showLoader" style="height:48px;" v-model="unLoadingCity" @input="searchUnLoading" :value="unLoadingCity" type="search" :placeholder="$t('message.unLoading_city')"></b-form-input>
      </b-input-group>
      <template v-if="searchOptions.length>0" class="route-select-body">
        <b-list-group>
          <div v-for="(searchValue,index) in searchOptions" v-bind:key="'searchValue'+index">
            <b-list-group-item @click="selectedRoute(index)">{{searchOptions[index].text}}</b-list-group-item>
          </div>
        </b-list-group>
      </template>
      <b-row>
        <b-col>
            <b-button v-if="searchOptions.length===0" type="submit" variant="dark" :disabled="preferred_btn_disabled" block @click="addPreferredRoute">
                {{ $t('message.preferred_routes_btn') }}
            </b-button>
        </b-col>
      </b-row>
      <!-- <div v-if="searchResultNotFound">
        <NoresultsFound/>
      </div> -->
    </template>
  </b-modal>
</template>

<script>
//import {ModelSelect} from 'vue-search-select'
import axios from "axios";
const commonUtil = require('../../util/commonUtil');
import {MX_TRACK} from '../../utils/Mixpanel';
import config from '../../config/config';
//import NoresultsFound from './NoresultsFound.vue';
export default {
  props: {
    routes_list: Array,
  },
  name: 'RouteModal',
  data() {
    return {
      showLoader: false,
      searchingOrigin:false,
      searchingDestination:false,
      searchResultNotFound:true,
      preferred_btn_disabled:true,
      searchOptions:[],
      loadingCity:'',
      unLoadingCity:'',
      loadingPointOptions: [],
      preferredRoutesList:[],
      loadingPoints: [],
      loadingPoint: {
        value: '',
        text: ''
      },
      unLoadingPointOptions: [],
      unLoadingPoints: [],
      unLoadingPoint: {
        value: '',
        text: ''
      },
    }
  },
  components: {
    //NoresultsFound
  },
  computed: {
    // isLoadingPoint() {
    //   return this.$v.loadingPoint.value.$dirty ? this.$v.loadingPoint.value.$error : null;
    // },
    // isUnloadingPoint() {
    //   return this.$v.unLoadingPoint.value.$dirty ? this.$v.unLoadingPoint.value.$error : null;
    // }
  },
  methods: {
    trackMixpanelEvent(event, data = {}) {
        const demandDetails = this.$store.getters.getDemandDetails.value
        const mx_prop = {
          time: new Date().getTime(),
          page_src: this.$route.name,
          user_type: demandDetails.user_type,
          user_name: demandDetails.supplier_name,
          phone_number: demandDetails.contact,
          language: this.$route.params.lang,
          demand_id: demandDetails.demand_id,
          bid_status: demandDetails.status,
        }
        MX_TRACK(event, {...mx_prop, ...data})
    },
    async selectedRoute(index){
      if(this.searchingOrigin){
        this.loadingPoint= {
          value: this.searchOptions[index].value,
          text: this.searchOptions[index].text
        }
        this.loadingCity = this.searchOptions[index].text
        const mxData = {origin:this.loadingPoint.text}
        this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ADD_ORIGIN_POINT_FOR_ROUTE, mxData)
        this.preferred_btn_disabled = this.loadingCity !== '' && this.unLoadingCity !== ''?false:true
        this.searchOptions = []
      }else{
        this.unLoadingPoint= {
          value: this.searchOptions[index].value,
          text: this.searchOptions[index].text
        }
        this.unLoadingCity = this.searchOptions[index].text
        const mxData = {destination:this.unLoadingPoint.text}
        this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ADD_DESTINATION_POINT_FOR_ROUTE, mxData)
        this.preferred_btn_disabled = this.loadingCity !== '' && this.unLoadingCity !== ''?false:true
        this.searchOptions = []
      }
    },
    async clear() {
      this.loadingPointOptions= [],
      this.loadingPoints= [],
      this.loadingPoint= {
        value: '',
        text: ''
      },
      this.unLoadingPointOptions= [],
      this.unLoadingPoints= [],
      this.unLoadingPoint= {
        value: '',
        text: ''
      },
      this.loadingCity='',
      this.unLoadingCity='',
      this.preferred_btn_disabled = true
    },
    async closeRoute(){
        this.$emit('add-route', {})
        this.clear();
        this.$refs['route-modal'].hide()
    },
    async addPreferredRoute(){
        this.showLoader = true;
        this.preferred_btn_disabled = true;
        const headers = {
            'Content-Type': 'application/json'
        }
        const body = [
            {
                origin:this.loadingPoint.text,
                destination:this.unLoadingPoint.text,
                origin_place_id:this.loadingPoint.value,
                destination_place_id:this.unLoadingPoint.value
            }]
      const {data} =  await axios.post(`/supplier_routes/${this.$route.params.id}/add`, body, {headers})
        if (data.success) {
             this.$confirm({
                title: this.$t('message.addedPreferredRoute'),
                message: this.$t('message.addedPreferredRouteConfirmMsgTxt', [`${this.loadingPoint.text} - ${this.unLoadingPoint.text}`]),
                button: {
                yes: this.$t('message.ok'),
                },
                callback: async (confirm) => {
                if (confirm == true) {
                  const mxData = {}
                  this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ADDED_A_PREFERRED_ROUTE, mxData)
                    this.clear();
                    this.showLoader = false;
                    this.preferred_btn_disabled = true;
                }
                }
            })
        }else{
            this.toast('danger', 'b-toaster-bottom-center', `${this.$t('message.failedToAddPreferredRouteMsgTxt')}`, true)
            this.clear();
            this.showLoader = false;
            this.preferred_btn_disabled = true;
        }
    },
    async addRoute() {
        this.showLoader = true;
        const body = {
          origin: this.loadingPoint.text,
          origin_place_id: this.loadingPoint.value,
          origin_terms: commonUtil.getPointTerms(this.loadingPoints, this.loadingPoint),
          destination: this.unLoadingPoint.text,
          destination_place_id: this.unLoadingPoint.value,
          destination_terms: commonUtil.getPointTerms(this.unLoadingPoints, this.unLoadingPoint),
        }
       this.$emit('add-route', body)
        this.$refs['route-modal'].hide()
       // this.clear();
        this.showLoader = false;
     // }
    },
    async searchLoading(text) {
      this.loadingCity = text;
      this.searchingOrigin = true;
      this.searchingDestination = false;
      if (text) {
        const {data} = await axios.get(`/place/autocomplete?input=${text}`)
        this.loadingPointOptions = [];
        this.loadingPoints = [];
        this.searchOptions = [];
        const list = data.data.predictions;
        if(list.length>0){
          this.searchResultNotFound = false
          for (let i = 0; list && i < list.length; i++) {
            this.loadingPointOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.searchOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.loadingPoints.push(list[i])
          }
        }else{
          this.searchResultNotFound = true
          this.loadingPoint= {
            value: '',
            text: ''
          }
        }
      }else{
        this.loadingPointOptions = [];
        this.loadingPoints = [];
        this.searchOptions = [];
        this.loadingPoint= {
          value: '',
          text: ''
        }
        this.searchResultNotFound = false;
      }
    },
    async searchUnLoading(text) {
      this.unLoadingCity = text;
      this.searchingOrigin = false;
      this.searchingDestination = true;
      if (text) {
        const {data} = await axios.get(`place/autocomplete?input=${text}`)
        this.unLoadingPointOptions = [];
        this.unLoadingPoints = [];
        this.searchOptions = [];
        const list = data.data.predictions;
        if(list.length>0){
          this.searchResultNotFound = false
          for (let i = 0; list && i < list.length; i++) {
            this.unLoadingPointOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.searchOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.unLoadingPoints.push(list[i])
          }
        }else{
          this.searchResultNotFound = true
          this.unLoadingPoint= {
            value: '',
            text: ''
          }
        }
      }else{
        this.searchOptions = [];
        this.unLoadingPointOptions = [];
        this.unLoadingPoints = [];
        this.unLoadingPoint= {
          value: '',
          text: ''
        }
        this.searchResultNotFound = false;
      }
    },
    toast(variant, toaster, text, append = false) {
            this.$bvToast.toast(text, {
                toaster: toaster,
                solid: true,
                variant: variant,
                appendToast: append,
                noCloseButton: true
            })
    }
  },
  async mounted() {
    this.$root.$on('on-add-preferred-route', async () => {
      //await this.preferredRoutes();
      this.$root.$emit('bv::show::modal', 'modal-center-routes')
    });
  }
}
</script>
<style lang="scss">
.routes-back-arrow{
    width:20px;
    height:20px;
    margin-top:11px;
    margin-left:15px;
    stroke:#707070;
    stroke-width:1px;
}
.modal-content {
    border-radius: 4px !important;
    min-height: 600px;
    max-height: 700px;
}
.input-group-text {
  background-color: #fff;
  border-right-color:#fff;
}
.list-group {
  max-height: 300px;
  min-height: 300px;
  overflow: auto;
}
// .modal-body {
//   overflow: auto;
// }
</style>
